import { useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useAppDispatch, useAppSelector } from '@/features/hooks'
import { editingSectionActions, EditingSectionKey } from '@/features/reservation-detail/editing-section-slice'

const SECTION_LABEL_KEYS: Record<EditingSectionKey, string> = {
  reservationInfo: 'Reservation Info',
  memo: 'Memo',
  sales: 'Usage details (sales)',
  discount: 'Usage details (discount)',
}

export const useReservationEditingSections = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const editingSections = useAppSelector(s => s.editingSection.editingSections)

  // 編集されているセクションがあるかどうか
  const hasUnsaved = useMemo(() => Object.values(editingSections).some(Boolean), [editingSections])

  // 編集されているセクションのラベル
  const unsavedLabels = useMemo(
    () =>
      (Object.keys(editingSections) as EditingSectionKey[])
        .filter(key => editingSections[key])
        .map(key => ({ key, label: t(SECTION_LABEL_KEYS[key]) })),
    [editingSections, t],
  )

  useEffect(() => {
    return () => {
      dispatch(editingSectionActions.resetEditingSections())
    }
  }, [dispatch])

  return {
    hasUnsaved,
    unsavedLabels,
  }
}
